import { ProductWithActiveColour, SortEnum, FiltersType } from '../types'

export const sortProducts = (
  products: ProductWithActiveColour[],
  filters: FiltersType,
  order: SortEnum
) => {
  switch (order) {
    case SortEnum.Recommended:
      const foundRecommended = products.some(item => item.recommended)

      // Only sort if there are products with recommended status
      if (foundRecommended) {
        return [...products].sort((a, b) => {
          if (a.recommended > b.recommended) return -1
          if (a.recommended < b.recommended) return 1
        })
      }

      return products

    case SortEnum.Lowest:
      return [...products].sort((a, b) => {
        const colourA = a.activeColour
        const colourAPrice = parseFloat(colourA.sale_price || colourA.price)

        const colourB = b.activeColour
        const colourBPrice = parseFloat(colourB.sale_price || colourB.price)

        return colourAPrice - colourBPrice
      })

    case SortEnum.Highest:
      return [...products].sort((a, b) => {
        const colourA = a.activeColour
        const colourAPrice = parseFloat(colourA.sale_price || colourA.price)

        const colourB = b.activeColour
        const colourBPrice = parseFloat(colourB.sale_price || colourB.price)

        return colourBPrice - colourAPrice
      })

    case SortEnum.Range:
      return [...products].sort((a, b) => a.range.localeCompare(b.range))

    case SortEnum.SeatType:
      const seatOrder = Array.from(filters.seatType.values()).map(
        type => type.title
      )

      return [...products].sort((a, b) => {
        return seatOrder.indexOf(a.seatType) - seatOrder.indexOf(b.seatType)
      })

    default:
      return products
  }
}
